import { Title, Label } from './components';

export const Card = {
	Label,
	Title,
};
